import { inject, Injectable } from "@angular/core";
import { WebOrderModel } from "../models/web-order.model";
import {
  doc,
  Firestore, getDoc, updateDoc,
} from "@angular/fire/firestore";
import { ObjectHelper } from "../helpers/object.helper";

@Injectable({
  providedIn: 'root',
})
export class WebOrderService {

  private firestore = inject(Firestore);

  async get(id: string): Promise<WebOrderModel|null> {
    const ref = doc(this.firestore, 'web-orders', id)
      .withConverter(WebOrderModel.converter);
    const docSnap = await getDoc(ref);
    if (!docSnap.exists()) {
      return null;
    }
    return docSnap.data();
  }

  /**
   * Update an order
   * @param id The id of the order to update
   * @param partialOrder The fields of the order to update
   * @returns The promise
   */
  public update(id: string, partialOrder: Partial<WebOrderModel>): Promise<void> {
    const ref = doc(this.firestore, 'web-orders', id).withConverter(WebOrderModel.converter);
    return updateDoc(ref, ObjectHelper.anonymize(partialOrder));
  }
}
